import { render, staticRenderFns } from "./PlainPlayer.vue?vue&type=template&id=0ab11644&scoped=true&"
import script from "./PlainPlayer.vue?vue&type=script&lang=js&"
export * from "./PlainPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PlainPlayer.vue?vue&type=style&index=0&id=0ab11644&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab11644",
  null
  
)

export default component.exports